import type { OpenSunsamaClient, RequestOptions } from "./client.js";

export interface WeeklyReviewTask {
  id: string;
  title: string;
  dueDate: string | null;
  scheduledDate: string | null;
  priority: "P0" | "P1" | "P2" | "P3";
  projectId: string | null;
  projectName: string | null;
  cycleId: string | null;
  completedAt: string | null;
}
export interface WeeklyReviewSummary {
  asOf: string;
  weekStart: string;
  timezone: string;
  overdue: WeeklyReviewTask[];
  unplanned: WeeklyReviewTask[];
  blocked: Array<
    WeeklyReviewTask & {
      blockers: Array<{
        id: string;
        title: string;
        completedAt: string | null;
      }>;
    }
  >;
  completed: WeeklyReviewTask[];
  staleCandidates: Array<{
    id: string;
    title: string;
    priority: string;
    dueDate: string | null;
    version: number;
    createdAt: string;
  }>;
  projects: { active: number; pastTarget: number };
  planning: { runsThisWeek: number; lastAppliedAt: string | null };
  reflection: {
    note: string;
    checks: Record<string, boolean>;
    updatedAt: string | null;
  };
}
interface ApiResponse<T> {
  success: boolean;
  data: T;
}
export function createWeeklyReviewApi(client: OpenSunsamaClient) {
  return {
    async get(
      asOf?: string,
      options?: RequestOptions
    ): Promise<WeeklyReviewSummary> {
      const response = await client.get<ApiResponse<WeeklyReviewSummary>>(
        "weekly-review",
        {
          ...options,
          searchParams: { ...options?.searchParams, asOf },
        }
      );
      return response.data;
    },
    async saveReflection(
      input: {
        weekStart: string;
        note: string;
        checks: Record<string, boolean>;
      },
      options?: RequestOptions
    ) {
      const response = await client.put<
        ApiResponse<WeeklyReviewSummary["reflection"] & { weekStart: string }>
      >("weekly-review/reflection", input, options);
      return response.data;
    },
  };
}
